export const HEADER_HEIGHT = 84;
